import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { WebSocketService } from 'src/app/service/websocket/web-socket.service';
import { AppUpdateServiceService } from 'src/app/services/app-update/app-update-service.service';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { jwtDecode } from 'jwt-decode';
// import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';
import { ToastrService } from 'ngx-toastr';
import { BiometricAuthService } from 'src/app/services/biometric-auth/biometric-auth.service';
import { AllPopupModalExecutionServiceService } from 'src/app/shared/services/all-popup-modal-execution-service.service';
import { FcmService } from 'src/app/services/fcm/fcm.service';

// import { SocialLogin } from '@capgo/capacitor-social-login';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup = new FormGroup({});
  passwordShow: any = 'password';
  showpwd: boolean = false;
  showPassword: boolean = false;
  formSubmitted: boolean = false;
  userRole: any;
  loggedInUserCompanyID: any;
  loggedInCompanyID: any;
  fiscalYear: any;
  userData: any = null;
  platform: any = null;
  getToken: any;
  autoLoginAttempted = false;
  deviceId: any = null;
  fcmToken!: string | null;

  constructor(
    private toastr: ToastrService,
    public router: Router,
    private http: HttpService,
    private config: Config,
    private loader: LoaderService,
    private fb: FormBuilder,
    private encryptionService: EncryptionService,
    private WebSocketServices: WebSocketService,
    public mobileResponsiveService: MobileResponsiveService,
    private appUpdateServiceService: AppUpdateServiceService,
    public dialog: MatDialog,
    private biometricService: BiometricAuthService,
    private allPopupModalExecutionServiceService: AllPopupModalExecutionServiceService,
    private fcmService: FcmService
  ) {
    // GoogleAuth.initialize({
    //   clientId: '873767787-2eit9qiek0l97gfifhjl1866vrhop7rb.apps.googleusercontent.com',
    //   scopes: ['profile', 'email'],
    //   grantOfflineAccess: true,
    // });
  }

  async ngOnInit() {
    this.fcmService.tokenSubject.subscribe({
      next: (value: any) => {
        this.fcmToken = value;
      }
    });

    this.appUpdateServiceService.getDeviceId().then((data: any) => {
      this.deviceId = data?.identifier || '';
    });
    this.platform = this.appUpdateServiceService.getPlatform();
    const updateAppLater = localStorage.getItem('updateAppLater');
    const todaysDate = new Date();

    if (!(updateAppLater && +updateAppLater >= Date.now())) {
      if (this.platform !== 'web') {
        this.appUpdateServiceService.isUpdateAvailable().subscribe({
          next: result => {
            if (result?.available) {
              const confObj: any = {
                disableClose: true,
                panelClass: 'phi-mdc-dialog__container',
                maxWidth: '340px',
                data: {
                  msg: 'A new version of app is available! Update now for the best experience.',
                  btn2: 'Update',
                  btn2BgColor: '#F6921E',
                  showSuccessIcon: true,
                  showSuccessMessage: false,
                  showCloseIcon: false
                }
              };
              if (!result.forceUpdate) confObj.data.btn1 = 'Later';
              this.dialog
                .open(ConfirmationPopupComponent, confObj)
                .afterClosed()
                .subscribe((update: boolean) => {
                  update ? window.open(result.downloadUrl, '_blank') : localStorage.setItem('updateAppLater', JSON.stringify(todaysDate.setDate(todaysDate.getDate() + 5)));
                });
            } else {
              localStorage.removeItem('updateAppLater');
            }
          },
          error: err => {}
        });
      }
    }

    this.inializeLoginForm();
    // this.initalizeGoogleLogin();

    // -------------- Login Woth Google Only For Desktop --------------

    // if (this.platform === 'web') {
    // this.renderGoogleBtn();
    // }

    // Attempt biometric auto-login (native platforms only)
    try {
      await this.tryBiometricAutoLogin();
    } catch (err) {}
  }

  // async initalizeGoogleLogin() {
  //   await SocialLogin.initialize({
  //     google: {
  //       iOSClientId: '920212327805-jn2n57hiuulu7lib2efan2fnqp15o8qs.apps.googleusercontent.com', // Required for iOS
  //       webClientId: '920212327805-ori8m7t1m92csnsa3huk9pt2v8dv7kdu.apps.googleusercontent.com', // Required for Android and Web
  //       mode: 'online' // 'online' or 'offline'
  //     }
  //   }).catch((error: any) => {});
  // }

  // -------------- Biometric auto-login attempt --------------
  async tryBiometricAutoLogin(): Promise<void> {
    // Only do biometric auto-login on native (android/ios) platforms
    if (this.platform === 'web') return;

    const creds = await this.biometricService.getVerifiedCredentials();
    if (!creds) return; // no creds or verification failed — nothing to do

    // set form fields and call manual branch using those credentials
    this.loginForm.controls['email'].setValue(creds.username);
    this.loginForm.controls['password'].setValue(creds.password);

    // Call onClickLogin as if form submitted (data == null branch)
    // We'll catch failures and remove biometric credentials if invalid
    this.formSubmitted = true;
    this.loader.simpleLoaderWithDuration();
    const request = {
      deviceId: this.deviceId,
      deviceType: this.platform,
      // deviceType: 'web',
      email: creds.username,
      empCode: '',
      fcmToken: this.fcmToken,
      password: creds.password
    };

    try {
      const data: any = await this.http.callPostServiceForLogin(this.config.login, request).toPromise();
      this.loader.dismissLoader();
      if (data?.accessToken) {
        // successful auto-login
        this.autoLoginAttempted = true;
        this.handlePostLoginSuccess(data);
      } else {
        // invalid stored credentials (password changed) — clear stored biometric credentials
        await this.biometricService.removeCredentials();
        this.allPopupModalExecutionServiceService.apiSuccessOrErrorMessage({ msg: 'Auto-login failed. Please login using email and password.' });
      }
    } catch (err) {
      await this.biometricService.removeCredentials();
      this.loader.dismissLoader();
      // leave user on login screen
    } finally {
      this.formSubmitted = false;
    }
  }

  // -------------- Existing code (render Google, google signins) --------------
  // renderGoogleBtn() {
  //   setTimeout(() => {
  //     const google = (window as any).google;
  //     if (google?.accounts?.id) {
  //       google.accounts.id.disableAutoSelect(); // Always clear One Tap session

  //       google.accounts.id.initialize({
  //         client_id: '873767787-2eit9qiek0l97gfifhjl1866vrhop7rb.apps.googleusercontent.com',
  //         callback: this.signInWithGoogleForDesktopOnly.bind(this),
  //         auto_select: false,
  //         cancel_on_tap_outside: true
  //       });

  //       google.accounts.id.renderButton(document.getElementById('google-button'), { theme: 'outline', size: 'large' });
  //     }
  //   }, 300); // slight delay ensures script loaded
  // }

  // ----------------------- Login Woth Google -----------------------
  // async signInWithGoogleForMobileOnly() {
  //   await SocialLogin.login({
  //     provider: 'google',
  //     options: {
  //       scopes: ['email', 'profile']
  //     }
  //   })
  //     .then((user: any) => {
  //       this.getToken = user?.result?.idToken ? user?.result?.idToken : '';
  //       this.onClickLogin(user?.result?.profile);
  //     })
  //     .catch((error: any) => {
  //       this.allPopupModalExecutionServiceService.apiSuccessOrErrorMessage({ msg: 'Google authentication failed. Please try again using an alternate sign-in method or retry after some time.' });
  //     });
  // }

  signInWithGoogleForDesktopOnly(response: any): void {
    const token = response.credential;
    this.getToken = token;
    try {
      const decoded: any = jwtDecode(token);
      this.onClickLogin(decoded);
    } catch (error) {}
  }

  ionViewWillEnter() {
    sessionStorage.removeItem('currentToken');
    sessionStorage.removeItem('refreshToken');
    sessionStorage.removeItem('loggedInUser');
    sessionStorage.removeItem('loggedInUserId');
    sessionStorage.removeItem('loggedInUserRole');
  }

  inializeLoginForm() {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/)]],
      password: ['', Validators.required]
    });
  }

  onEyeClick() {
    this.showPassword = !this.showPassword;
    this.passwordShow = this.showPassword ? 'text' : 'password';
    this.showpwd = this.showPassword;
  }

  // -------------- Main login handler — unchanged structure but with post-login hook --------------
  onClickLogin(data: any) {
    this.formSubmitted = true;
    if (!data) {
      // Manual email/password login
      this.loginForm.controls['email'].setValue(this.loginForm.value.email?.trim());
      if (this.loginForm.valid) {
        this.formSubmitted = false;
        const request = {
          deviceId: this.deviceId,
          deviceType: this.platform,
          // deviceType: 'web',
          email: this.loginForm.value.email,
          empCode: '',
          fcmToken: this.fcmToken,
          password: this.loginForm.value.password
        };
        this.loader.simpleLoaderWithDuration();
        this.http.callPostServiceForLogin(this.config.login, request).subscribe({
          next: async (data: any) => {
            this.loader.dismissLoader();
            if (data?.accessToken) {
              // After manual success, ask user to enable biometric (only on native)
              // Do not prompt if we were in an auto-login attempt
              if (!this.autoLoginAttempted && this.platform !== 'web') {
                try {
                  const available = await this.biometricService.isAvailable();
                  if (available) {
                    const enable = this.allPopupModalExecutionServiceService.confirmationPopupComponentExe({ msg: 'Enable biometric login for faster access next time?' });
                    await enable.afterClosed().subscribe(async (confirmed: any) => {
                      if (confirmed) {
                        await this.biometricService.saveCredentials(this.loginForm.value.email, this.loginForm.value.password);
                        this.toastr.success('Biometric login enabled.');
                      }
                    });

                    // const enable = window.confirm('Enable biometric login for faster access next time?');
                    // if (enable) {
                    // Save credentials (email + password) for future biometric auth
                    // }
                  }
                } catch (err) {}
              }

              // login success: do the same post-login steps you had before
              setTimeout(() => {
                this.handlePostLoginSuccess(data);
              }, 300);
            } else {
              this.allPopupModalExecutionServiceService.apiSuccessOrErrorMessage({ msg: data?.data });
            }
          },
          error: (error: any) => {
            this.allPopupModalExecutionServiceService.apiSuccessOrErrorMessage({ msg: 'Login failed please try later' });
            this.loader.dismissLoader();
          }
        });
      }
    } else {
      // Google login flow (data contains decoded token or google user)
      this.formSubmitted = false;
      const request = {
        deviceId: this.deviceId,
        deviceType: this.platform,
        // deviceType: 'web',
        email: data?.email,
        empCode: '',
        fcmToken: this.fcmToken,
        idToken: this.getToken
      };
      this.loader.simpleLoaderWithDuration();
      this.http.callPostServiceForLogin(this.config.googlelogin, request).subscribe({
        next: async (data: any) => {
          this.loader.dismissLoader();
          if (data?.accessToken) {
            this.handlePostLoginSuccess(data);
          } else {
            this.allPopupModalExecutionServiceService.apiSuccessOrErrorMessage({ msg: data?.data });
          }
        },
        error: (error: any) => {
          this.allPopupModalExecutionServiceService.apiSuccessOrErrorMessage({ msg: 'Login failed please try later' });
          this.loader.dismissLoader();
        }
      });
    }
  }

  // -------------- Centralized code for post-login actions previously in multiple places --------------
  private handlePostLoginSuccess(data: any) {
    this.loader.dismissLoader();

    let superManager = 'NOManager';
    const hasHOD = data?.roles?.some((role: any) => role.displayName === 'HOD');
    const hasManager = data?.roles?.some((role: any) => role.displayName === 'Manager');

    if (hasHOD && hasManager) superManager = 'HODManager';

    sessionStorage.setItem('HODManager', superManager);
    sessionStorage.setItem('currentToken', data?.accessToken);
    sessionStorage.setItem('department', data?.userProfile?.department);
    sessionStorage.setItem('userCompanyHr', data.userProfile?.userCompanyHr);
    sessionStorage.setItem('refreshToken', data?.refreshToken);
    sessionStorage.setItem('loggedInUserName', data?.userProfile?.firstName + ' ' + data?.userProfile?.lastName);
    sessionStorage.setItem('loggedInUserId', data?.userProfile?.id);
    sessionStorage.setItem('userEmail', data?.userProfile?.email);
    sessionStorage.setItem('empCode', data?.userProfile?.empCode);
    sessionStorage.setItem('isDottedManager', data?.userProfile?.isDottedManager);
    sessionStorage.setItem('loggedInUserRoles', JSON.stringify(data?.roles));

    this.userRole = this.encryptionService.encryptData(data?.roles[0]?.displayName);
    sessionStorage.setItem('loggedInUserRole', this.userRole);
    this.loggedInCompanyID = this.encryptionService.encryptData(String(data?.userProfile?.companyId));
    sessionStorage.setItem('loggedInUserCompanyID', this.loggedInCompanyID);

    this.loggedInUserCompanyID = data?.userProfile?.companyId;
    if (data?.roles[0]?.displayName?.toLowerCase() == 'super admin' || data?.roles[0]?.displayName?.toLowerCase() == 'phi admin' || data?.roles[0]?.displayName?.toLowerCase() == 'phi finance & accounts') {
      sessionStorage.setItem('subModuleButtonColor', '#393186');
      sessionStorage.setItem('buttonColorName', '#F6921E');
      sessionStorage.setItem('moduleNameColor', '#F6921E');
      this.router.navigate(['/home/companies']);
    } else {
      this.getMdIdByCompany();
      data?.roles?.forEach((ele: any) => {
        if (ele?.displayName == 'Admin') {
          this.userRole = this.encryptionService.encryptData(ele?.displayName);
          sessionStorage.setItem('loggedInUserRole', this.userRole);
        }
      });
      this.getCompanyDataByCompID();
      this.WebSocketServices.openWebSocket();
    }
  }

  // ------------------------------------------------login with otp --------------------------------------------------
  userEmailOrPhone: string = '';
  otpSent: boolean = false;
  otpModalOpen: boolean = false;

  otpDigits: string[] = ['', '', '', '', '', ''];
  otpLength: number = 6; // change to 6 if needed

  resendCountdown: number = 30;
  timer: any;

  // ----------------- OTP Modal Control -----------------
  openOtpModal() {
    this.otpModalOpen = true;
  }

  closeOtpModal() {
    this.otpModalOpen = false;
    this.reset();
  }

  // ----------------- Step 1: Send OTP -----------------
  sendOtp() {
    const email = this.loginForm.value.email;
    if (!email) {
      this.allPopupModalExecutionServiceService.apiSuccessOrErrorMessage({ msg: 'Please Enter Valid Email Id' });
      return;
    }
    const payload = {
      email,
      deviceId: this.deviceId,
      deviceType: this.platform,
      // deviceType: 'web',
      fcmToken: this.fcmToken
    };

    this.http.callPostServiceForLogin(this.config.sendOtp, payload).subscribe({
      next: (data: any) => {
        if (data?.status) {
          this.otpSent = true;
          this.userEmailOrPhone = email;
          this.startTimer();
          this.toastr.success('OTP sent successfully!', 'Success');
        } else {
          this.allPopupModalExecutionServiceService.apiSuccessOrErrorMessage({ msg: data.message });
          // if (data.message == 'Invalid email format') {
          // } else {
          //   this.allPopupModalExecutionServiceService.apiSuccessOrErrorMessage({ msg: 'User with ' + email + ' does not exist' });
          // }
        }
      },
      error: err => {
        if (err?.error?.message) {
          this.allPopupModalExecutionServiceService.apiSuccessOrErrorMessage({ msg: err?.error?.message });
          //   this.allPopupModalExecutionServiceService.apiSuccessOrErrorMessage({ msg: 'Please Enter Valid Email Id' });
          // } else {
          //   this.allPopupModalExecutionServiceService.apiSuccessOrErrorMessage({ msg: 'User with ' + email + ' does not exist' });
        } else {
          this.allPopupModalExecutionServiceService.apiSuccessOrErrorMessage({ msg: 'Login failed please try later' });
        }
      }
    });
  }

  clearOtp() {
    // ✅ Clear all OTP array values
    this.otpDigits = new Array(this.otpLength).fill('');

    // ✅ Also clear the input field values from DOM (optional, ensures UI reset)
    const inputs = document.querySelectorAll<HTMLInputElement>('.otp-inputs input');
    inputs.forEach(input => (input.value = ''));

    // ✅ Set focus back to first input box
    inputs[0]?.focus();
  }

  // ----------------- Step 2: Verify OTP -----------------
  verifyOtp() {
    const otp = this.otpDigits.join('');
    if (otp.length < this.otpLength) {
      this.allPopupModalExecutionServiceService.apiSuccessOrErrorMessage({ msg: 'Please enter complete OTP' });
      return;
    }
    const email = this.loginForm.value.email;
    const payload = {
      email,
      otp,
      deviceId: this.deviceId,
      deviceType: this.platform,
      // deviceType: 'web',
      fcmToken: this.fcmToken
    };
    this.http.callPostServiceForLogin(this.config.veryfyOtp, payload).subscribe({
      next: (data: any) => {
        if (data?.accessToken) {
          this.handlePostLoginSuccess(data);
        } else {
          this.otpDigits = ['', '', '', '', '', ''];
          this.clearOtp();
          this.allPopupModalExecutionServiceService.apiSuccessOrErrorMessage({ msg: data?.data });
        }
      },
      error: (error: any) => {
        clearInterval(this.timer);
        this.allPopupModalExecutionServiceService.apiSuccessOrErrorMessage({ msg: 'Invalid OTP' });
      }
    });
  }

  onOtpInput(event: any, index: number) {
    const input = event.target;
    input.value = input.value.replace(/[^0-9]/g, ''); // allow only digits

    if (input.value.length === 1) {
      this.otpDigits[index] = input.value;
      const nextInput = document.querySelectorAll<HTMLInputElement>('.otp-inputs input')[index + 1];
      nextInput?.focus();
    } else {
      input.value = input.value.charAt(0); // only 1 digit
    }
  }

  // ----------------- Timer & Resend -----------------
  startTimer() {
    this.resendCountdown = 30;
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      this.resendCountdown--;
      if (this.resendCountdown === 0) clearInterval(this.timer);
    }, 1000);
  }

  // resendOtp() {
  //   this.sendOtp();
  // }

  // ----------------- Input Navigation -----------------

  moveNext(event: any, index: number) {
    const input = event.target;

    // move forward when a digit is typed
    if (input.value && index < this.otpLength - 1) {
      input.nextElementSibling?.focus();
    }

    // move backward on delete
    if (!input.value && event.inputType === 'deleteContentBackward' && index > 0) {
      input.previousElementSibling?.focus();
    }
  }

  handlePaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedData = event.clipboardData?.getData('text') || '';
    const digits = pastedData.replace(/\D/g, '').slice(0, this.otpLength).split('');

    digits.forEach((digit, index) => {
      this.otpDigits[index] = digit;
    });

    // Move focus to the last filled box
    const inputs = document.querySelectorAll<HTMLInputElement>('.otp-inputs input');
    const nextIndex = digits.length < this.otpLength ? digits.length : this.otpLength - 1;
    inputs[nextIndex]?.focus();
  }

  // ----------------- Reset -----------------
  reset() {
    this.otpSent = false;
    this.userEmailOrPhone = '';
    this.otpDigits = ['', '', '', '', '', ''];
    clearInterval(this.timer);
    // if (this.platform === 'web') {
    //   this.renderGoogleBtn();
    // }
  }
  // ------------------------------------------------login with otp --------------------------------------------------
  onClickForgotPassword() {
    this.router.navigate(['/login/forgot-password'], {
      queryParams: { email: this.loginForm?.value?.email?.trim() || '' }
    });
  }
  getCompanyDataByCompID() {
    this.loader.simpleLoaderWithDuration();
    this.http.callGetService(this.config.getCompanyDataByCompID + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.loader.dismissLoader();
      sessionStorage.setItem('loggedInUserCompanyName', data?.data?.companyName);
      sessionStorage.setItem('loggedInCompanyData', JSON.stringify(data?.data));
      sessionStorage.setItem('subModuleButtonColor', data?.data?.subModuleButtonColor);
      sessionStorage.setItem('buttonColorName', data?.data?.buttonColorName);
      sessionStorage.setItem('moduleNameColor', data?.data?.moduleNameColor);
      sessionStorage.setItem('dashboardColorName', data?.data?.dashboardColorName);
      sessionStorage.setItem('companyLogo', data?.data?.logo);
      this.fiscalYear = this.encryptionService.encryptData(data?.data?.fiscalYear);
      sessionStorage.setItem('loggedInCompanyFiscalyear', this.fiscalYear);
      sessionStorage.setItem('loggedInCompanyIndustryName', data?.data?.industry?.industryName);
      sessionStorage.setItem('loggedInCompanyIndustryID', data?.data?.industry?.id);
      sessionStorage.setItem('loggedInCompanyMDCode', data?.data?.employeeIdOfMD);
      if (sessionStorage.getItem('empCode') == data?.data?.employeeIdOfMD) {
        sessionStorage.setItem('loggedInUserIsMD', 'true');
      }

      if (this.loggedInUserCompanyID) {
        const companyID = Number(this.loggedInUserCompanyID);
        if (companyID) {
          if (companyID == 32867 || companyID == 32869) {
            this.router.navigate(['/home/hrportal/competency']);
          } else {
            this.router.navigate(['/home/hrportal/dwmplus']);
          }
        }
      }
    });
  }
  loggedInCompanyMDID: any;
  getMdIdByCompany() {
    var loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.http.callGetService(this.config.getMdIdByCompany + loggedInUserCompanyID).subscribe((data: any) => {
      this.loggedInCompanyMDID = this.encryptionService.encryptData(String(data?.data?.id));
      sessionStorage.setItem('loggedInCompanyMDID', this.loggedInCompanyMDID);
      this.getCountOfUnreadNotification();
    });
  }
  activeNotificationConunt: any;
  getCountOfUnreadNotification() {
    let loggedInUserRole: any = sessionStorage.getItem('loggedInUserRole');
    loggedInUserRole = this.encryptionService.decryptData(loggedInUserRole);
    const loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.http.callGetService(this.config.getCountOfUnreadNotification + loggedInUserId + '/' + loggedInUserRole).subscribe((response: any) => {
      this.activeNotificationConunt = response?.data ? response?.data : 0;
      this.activeNotificationConunt = this.activeNotificationConunt > 99 ? '99+' : this.activeNotificationConunt.toString();
      localStorage.setItem('NotificationCount', this.activeNotificationConunt);
    });
  }
}
